import { render } from "./6.PartnersSection.vue?vue&type=template&id=fe565ca4&scoped=true"
import script from "./6.PartnersSection.vue?vue&type=script&lang=js"
export * from "./6.PartnersSection.vue?vue&type=script&lang=js"

import "./6.PartnersSection.vue?vue&type=style&index=0&id=fe565ca4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe565ca4"]])

export default __exports__